import fetchData from '@/lib/fetchData';
import processJSON from '@/lib/processJSON';

import act__lpoList from './act__lpoList';
import current__section from './current__section';
//import recount from './current__recount';

const ROOT_API = process.env.VUE_APP_ROOT_API;
const GET_LEASE = ROOT_API + 'get_lease.php';
const GET_CURRENT_LPO = ROOT_API + 'lpo_data/get_current_lpo.php';
const GET_ACT_LPO_LIST = ROOT_API + 'act_data/get_act_lpo_list.php';
// const CREATE_LEASE = ROOT_API + 'create_lease.php';

export default {
	namespaced: true,

	modules: {
		act__lpoList,
		current__section,
		//recount
	},

	state: {
		actLpo: null,

		currentLpo: null,
		currentLpoLoading: false,

		actLpoList: [],
		actLpoListLoading: false
	},

	getters: {
		actLpoIsDraft: (state) => {
			return state.currentLpo?.is_draft === 't';
		}
	},

	mutations: {
		setActLpo(state, payload) { state.actLpo = payload; },

		setCurrentLpo(state, payload) { state.currentLpo = payload; },
		setCurrentLpoLoading(state, payload) { state.currentLpoLoading = payload; },

		setActLpoList(state, payload) { state.actLpoList = payload; },
		setActLpoListLoading(state, payload) { state.actLpoListLoading = payload },

		clearCurrentLpoData(state) {
			state.currentLpo = null;
			state.actLpoList = [];
		}
	},

	actions: {
		FETCH_ACT_LPO({ state, commit }) {
			const lease_id = state.currentLpo.lease_id;
			
			const form = new FormData();
			form.append('lease_id', lease_id);

			return fetch(GET_LEASE, {
				credentials: 'include',
				method: 'post',
				body: form
			})
			.then(res => res.json())
			.then(res => {
				commit('setActLpo', res);
			})
			.catch(err => { throw err; });
		},


		getCurrentLpoData(context, lpo_id) {
			const { state, dispatch } = context;

			return dispatch('getCurrentLpo', lpo_id).then(res => {
				dispatch('FETCH_ACT_LPO');
				return dispatch('getActLpoList');
			}).catch(err => {
				throw err;
			});
		},

		getCurrentLpo(context, lpo_id) {
			const { commit } = context;

			const form = new FormData();
			form.append('lpo_id', lpo_id);

			commit('setCurrentLpoLoading', true);

			return fetchData(GET_CURRENT_LPO, form).then(data_lpo => {

				if (!data_lpo) {
					throw new Error('NO_DATA_LPO');
				}

				commit('setCurrentLpo', data_lpo);
			}).catch(err => {
				throw err;
			}).finally(() => {
				commit('setCurrentLpoLoading', false);
			});
		},

		getActLpoList(context) {
			const { state, commit } = context;

			const currentLpo = state.currentLpo;
			if (!currentLpo) {
				throw new Error('NO_CURRENT_LPO');
			}

			if (!currentLpo.lease_id) {
				throw new Error('CURRENT_LPO_HAS_NO_LEASE_ID');
			}

			const form = new FormData();
			form.append('lease_id', currentLpo.lease_id);

			commit('setActLpoListLoading', true);

			return fetchData(GET_ACT_LPO_LIST, form).then(res => {
				commit('setActLpoList', res);
			}).catch(err => {
				throw err;
			}).finally(() => {
				commit('setActLpoListLoading', false);
			});
		},

		TOGGLE_ACT_DRAFT({ state }) {
			const is_draft = state.currentLpo.is_draft === 't';

			const json_obj = [
				{
					'u': [
						{
							'tab_name': 'data_lpo_lease',
							'f_v': {
								'id': state.currentLpo.lease_id,
								'is_draft': !is_draft
							}
						}
					]
				}
			];
			const json_str = JSON.stringify(json_obj);

			return processJSON(json_str);
		},

		removeCurrentLpo(context, payload) {
			const { state } = context;

			const json_obj = [
				{
					'd': [
						{
							'tab_name': 'data_lpo',
							'id': state.currentLpo.lpo_id
						}
					]
				}
			];

			/* если в группе одно обследование, значит нужно также удалить и аренду */
			if (state.actLpoList.length === 1) {

				if (state.currentLpo.lpo_id !== state.actLpoList[0].lpo_id) {
					throw new Error('MISMATCH_LPO_ID_WHILE_REMOVE_LPO');
				}

				if (!state.currentLpo.lease_id) {
					throw new Error('CURRENT_LPO_HAS_NO_LEASE_ID');
				}

				const tempLease = {
					'tab_name': 'data_lpo_lease',
					'id': state.currentLpo.lease_id
				};
				json_obj[0].d.push(tempLease);
			}

			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;

			return processJSON(json_str);
		}

	}
};